<template>
  <VModal :showing="showing" :overflow-content="true" container-classes="w-full max-w-xl" @update:showing="onClose">
    <template #header>
      <h2 class="text-lg m-0">{{ title }}</h2>
      <div class="text-sm text-gray-600 font-normal">Localization helps position data in the right location</div>
    </template>

    <DataFilesOriginLocalizationManager
      :deck="deck"
      :drill-data-set="drillDataSet"
      :initial-drill-data-set-layer-group="initialDrillDataSetLayerGroup"
      :is-internal-admin="isInternalAdmin"
      :drill-data-set-manager="drillDataSetManager"
      @update:showing="onClose"
      @success="onSuccess"
      @update:header="updateHeader($event)"
    />
  </VModal>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'
import { ref } from 'vue'

import type { DrillDataSetManager } from '~/lib/three-d-resources/drill-data-set-manager'
import type { EditDeck } from '~/composables/useEditDeck'
import type { Drill } from '~/entities/drill'

defineProps({
  showing: {
    type: Boolean,
    default: false,
  },
  deck: {
    type: Object as PropType<DeepReadonly<EditDeck>>,
    required: true,
  },
  drillDataSetManager: {
    type: Object as PropType<DrillDataSetManager>,
    required: true,
  },
  drillDataSet: {
    type: Object as PropType<Drill | null>,
    default: null,
  },
  initialDrillDataSetLayerGroup: {
    type: Object as PropType<DrillDataSetLayerGroup | null>,
    default: null,
  },
  isInternalAdmin: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:showing', 'notify'])

const title = ref('Choose a Localization')

function onClose() {
  emit('update:showing', false)
}

function onSuccess() {
  emit('notify', {
    title: 'Data updated',
    text: 'All changes were saved successfully.',
  })
  onClose()
}

function updateHeader(mode: string) {
  title.value = mode
}
</script>
